import './format.scss';
import Vue from "vue";
const updateMask = async (el, _bind, node) => {
  await Vue.nextTick(); // 等待 number-input 组件更新数据
  const { componentInstance: { currentValue: value, displayValue, numPrecision }, data: { attrs: { prefix, suffix }}} = node;
  const noFormat = el.classList.contains('no-format');
  const relVal = value || 0;
  const str = noFormat ? displayValue : getNumString(relVal, numPrecision);
  el.querySelector(".plus-el .value").innerText = str;
  el.querySelector(".plus-el .prefix").innerText = prefix ?? '';
  el.querySelector(".plus-el .suffix").innerText = suffix ?? '';
};
export function getNumString(value, numPrecision) {
  return value ? (+value).toLocaleString('zh', { minimumFractionDigits: ~~numPrecision }) : value;
}
export const format = {
  bind(el) {
    const input = el.querySelector("input.el-input__inner");
    const mask = document.createElement("div");
    const suffix = document.createElement("div");
    const prefix = document.createElement("div");
    const plusEl = document.createElement("div");
    const value = document.createElement("div");
    mask.className = input.className + " mask";
    value.className = "value";
    plusEl.className = "plus-el";
    prefix.className = "prefix";
    suffix.className = "suffix";
    mask.appendChild(plusEl);
    plusEl.appendChild(prefix);
    plusEl.appendChild(suffix);
    plusEl.appendChild(value);
    input.insertAdjacentElement("beforebegin", mask);
    input.addEventListener("focus", () => {
      mask.classList.add('hidden-format');
    });
    input.addEventListener("blur", () => {
      mask.classList.remove('hidden-format');
    });
    updateMask.apply(this, arguments);
  },
  update: updateMask,
  unbind(el) {
    const mask = el.querySelector(".mask");
    mask.remove();
  }
};
